import { NationalUniversityOfSingaporeLogo } from '@jouzen/ecom-components/icons/NationalUniversityOfSingaporeLogo';
import { SduLogo } from '@jouzen/ecom-components/icons/SduLogo';
import { UclaLogo } from '@jouzen/ecom-components/icons/UclaLogo';
import { UcsfLogo } from '@jouzen/ecom-components/icons/UcsfLogo';
import { UniversityOfMichiganLogo } from '@jouzen/ecom-components/icons/UniversityOfMichiganLogo';
import { UtokyoLogo } from '@jouzen/ecom-components/icons/UtokyoLogo';

import LandingPageIntegrations from '@/app/components/LandingPage/LandingPageIntegrations';
import type { LandingPageIntegrationData } from '@/app/components/LandingPage/LandingPageIntegrations/types';

import useSAndR2025 from '../_hooks/useSAndR2025';

const defaultIntegrations: LandingPageIntegrationData[] = [
  {
    description: 'science_and_research_universities_one',
    name: 'University of California, San Francisco',
    Logo: UcsfLogo,
  },
  {
    description: 'science_and_research_universities_three',
    name: 'University of California, Los Angeles',
    Logo: UclaLogo,
  },
  {
    description: 'science_and_research_universities_five',
    name: 'University of Tokyo',
    Logo: UtokyoLogo,
  },
  {
    description: 'science_and_research_universities_two',
    name: 'National University of Singapore',
    Logo: NationalUniversityOfSingaporeLogo,
  },
  {
    description: 'science_and_research_universities_four',
    name: 'University of Michigan',
    Logo: UniversityOfMichiganLogo,
  },
  {
    description: 'science_and_research_universities_six',
    name: 'SDU',
    Logo: SduLogo,
  },
];

const update2025Integrations: LandingPageIntegrationData[] = [
  {
    description: 'science_and_research_universities_one',
    name: 'University of California, San Francisco',
    Logo: UcsfLogo,
    logoClassName: 'mb-12!',
  },
  {
    description: 'science_and_research_universities_three',
    name: 'University of California, Los Angeles',
    Logo: UclaLogo,
    logoClassName: 'mb-12!',
  },
  {
    description: 'science_research_2025_scripps_study_copy',
    image: {
      alt: 'Scripps',
      height: 64,
      src: '/logos/scripps-logo.svg',
      width: 61,
    },
    name: 'Scripps',
  },
  {
    description: 'science_and_research_universities_two',
    name: 'National University of Singapore',
    Logo: NationalUniversityOfSingaporeLogo,
    logoClassName: 'mb-12!',
  },
  {
    description: 'science_research_2025_dime_study_copy',
    image: {
      alt: 'Dime',
      className: 'mb-12',
      height: 41,
      src: '/logos/dime-logo.svg',
      width: 111,
    },
    name: 'Dime',
  },
  {
    description: 'science_and_research_universities_four_2025',
    name: 'University of Michigan',
    Logo: UniversityOfMichiganLogo,
    logoClassName: 'mb-12!',
  },
];

const ScienceAndResearchUniversities = () => {
  const isRolloutEnabled = useSAndR2025();

  return (
    <section className="py-20" data-cy="science-and-research-universities">
      <LandingPageIntegrations
        integrations={
          isRolloutEnabled ? update2025Integrations : defaultIntegrations
        }
      />
    </section>
  );
};

export default ScienceAndResearchUniversities;
